import { render, staticRenderFns } from "./list_novelties_component.vue?vue&type=template&id=27b1d55c&scoped=true"
import script from "./list_novelties_component.vue?vue&type=script&lang=js"
export * from "./list_novelties_component.vue?vue&type=script&lang=js"
import style0 from "./list_novelties_component.vue?vue&type=style&index=0&id=27b1d55c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1d55c",
  null
  
)

export default component.exports